<template>
  <div>
    <b-modal
        v-model="modalVisible"
        id="modal-produto"
        ok-only
        ok-variant="outline-secondary"
        ok-title="Sair"
        size="lg"
        centered
        :title="titleModal"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="estabelecimento">ESTABELECIMENTO</label>
              <b-form-input
                  id="estabelecimento"
                  type="text"
                  placeholder="ESTABELECIMENTO"
                  v-model="produto.estabNomeFantasia"
                  :disabled="true"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="produto">PRODUTO</label>
              <b-form-input
                  id="produto"
                  type="text"
                  placeholder="PRODUTO"
                  v-model="produto.item_descricao"
                  :disabled="true"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="data">DATA DE PUBLICAÇÃO</label>
              <b-form-input
                  id="data"
                  type="text"
                  placeholder="DATA DE PUBLICAÇÃO"
                  v-model="produto.created_at"
                  :disabled="true"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" class="mt-2">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="download"
            >
              <feather-icon icon="DownloadIcon" size="18" />
              <span class="align-middle ml-25">Baixar</span>
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import { title } from '@core/utils/filter';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BFormSelect,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      modalVisible: false,
      produto: {},
      titleModal: '',
    };
  },
  methods: {
    async download() {
      try {
        const link = document.createElement('a');

        link.href = '/caractTecnicas/E__KS_AplicacoesWeb_Pedidos_Uploads_PortalCliente_CaracTec_NP9026VIR01.pdf';

        link.download = 'E__KS_AplicacoesWeb_Pedidos_Uploads_PortalCliente_CaracTec_NP9026VIR01.pdf';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: 'Erro ao fazer download do PDF',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        console.error('Erro ao fazer download do PDF:', error);
      }
    },
    title,
    abrirModal(tipoOperacao, dados = null) {
      if (tipoOperacao === 'caract') {
        this.titleModal = 'Características técnicas';
        this.produto = dados;
      } else if (tipoOperacao === 'cond') {
        this.titleModal = 'Condições Fornecimento e Garantia';
        this.produto = dados;
      }

      this.modalVisible = true;
    },
    onSubmit() {
      this.$emit('salvarEndereco', { ...this.produto });

      this.modalVisible = false;
    },
  },
};
</script>
